import {call, delay, put, select, takeLatest} from 'redux-saga/effects'

import * as checkoutActions from '../../actions/checkout'
import * as rtkActions from '../../actions/rentToKeep'
import * as report from '../../report'
import * as worldpayActions from '../../actions/worldpay'
import {id as currentUserId} from '../../store/user'
import * as worldpayResponseCodes from './responseCodes'
import {currentOrderId} from '../../store/events'
import * as track from '../../track/track'
import * as addItemsActions from '../../pages/OrderManager/CheckoutAddItem/PaymentStep/redux/actions'

export function* fetchPaypageRegistrationIdWorker({payload}) {
  yield put(worldpayActions.fetchPaypageRegistrationIdPending())

  let userId = payload?.userId
  let orderId = payload?.orderId

  if (!userId || !orderId) {
    userId = yield select(currentUserId)
    orderId = yield select(currentOrderId)
  }

  yield call(report.setUser, {id: userId})
  yield call(report.setExtra, 'orderId', orderId)

  try {
    yield call(window.eProtectiframeClient.getPaypageRegistrationId, {
      id: `${userId}-${orderId}`,
      orderId,
    })
  } catch (e) {
    yield put(worldpayActions.fetchPaypageRegistrationIdFailure())
  }
}

export function* fetchPaypageRegistrationIdSaga() {
  yield takeLatest(
    [
      checkoutActions.SAVE_BILLING_ADDRESS_SUCCESS,
      rtkActions.SAVE_RTK_BILLING_INFORMATION_SUCCESS,
      addItemsActions.GENERATE_WORLDPAY_PAYPAGE_TOKEN,
    ],
    fetchPaypageRegistrationIdWorker,
  )
}

export function* handleWorldPayAuthorizationWorker({payload}) {
  /* This handles the response from the "getPayageRegistrationId" api call. The initial
  call is in the fetchPaypageRegistrationIdWorker */

  const {message: responseMessage, response: responseCode, timeout} = payload

  if (responseCode === worldpayResponseCodes.SUCCESS) {
    yield put(worldpayActions.fetchPaypageRegistrationIdSuccess(payload))
    return
  }

  yield put(
    worldpayActions.fetchPaypageRegistrationIdFailure({responseCode, responseMessage, timeout}),
  )
}

export function* handleWorldPayAuthorizationSaga() {
  yield takeLatest(worldpayActions.HANDLE_WORLDPAY_AUTHORIZATION, handleWorldPayAuthorizationWorker)
}

export function* handleWorldPayErrorResponseWorker({payload}) {
  const {responseCode, responseMessage, timeout} = payload

  // TODO: replace alert dialogs with better error messaging to the user
  // This delay addresses a race condition issue with the loading state of the submit button
  // remaining activated indefinitely due to the alert dialogs below blocking Javascript execution
  // until they are closed and allowing the Redux actions to disable the loading animation to run
  yield delay(50)

  // worldpay authorization timed out, send error to sentry (should send error to segment??)
  if (timeout) {
    yield call(
      alert,
      'We are experiencing technical difficulties. Please try again or call us to complete your order (timeout)',
    )
    yield call(report.message, 'Worldpay iframe Timeout')
    return
  }

  // send error to segment event indicating an iframe error occurred
  track.checkoutIframeError(responseCode, responseMessage)

  switch (responseCode) {
    case worldpayResponseCodes.ACCOUNT_NUMBER_NOT_MOD_10:
    case worldpayResponseCodes.ACCOUNT_NUMBER_TOO_SHORT:
    case worldpayResponseCodes.ACCOUNT_NUMBER_TOO_LONG:
    case worldpayResponseCodes.ACCOUNT_NUMBER_NOT_NUMERIC:
    case worldpayResponseCodes.ACCOUNT_NUMBER_INVALID:
      yield call(alert, 'Please check and re-enter your credit card number and try again.')
      break
    case worldpayResponseCodes.CARD_VALIDATION_NUM_NOT_NUMERIC:
    case worldpayResponseCodes.CARD_VALIDATION_NUM_TOO_SHORT:
    case worldpayResponseCodes.CARD_VALIDATION_NUM_TOO_LONG:
      // Recoverable error caused by user mis-typing their credit card
      yield call(alert, 'Please check and re-enter your card validation number and try again.')
      break
    case worldpayResponseCodes.IFRAME_HTML_FAILED_TO_LOAD:
      yield call(report.message, 'Worldpay iframe failed to load (response code 884)')
      break
    case worldpayResponseCodes.IFRAME_CSS_FAILED_TO_LOAD:
      yield call(report.message, 'Worldpay iframe CSS failed to load (response code 885)')
      break
    default:
      yield call(report.message, `Worldpay iframe failure (response code ${responseCode})`)
      yield call(
        alert,
        'We are experiencing technical difficulties. Please try again or contact us at support@theblacktux.com',
      )
  }
}

export function* handleWorldPayErrorResponseSaga() {
  yield takeLatest(
    worldpayActions.FETCH_PAYPAGE_REGISTRATION_ID_FAILURE,
    handleWorldPayErrorResponseWorker,
  )
}
